import BX from 'BX';
import { format } from '../libs/phone-mask-formatter';
import Vue from 'vue';
import once from 'ramda/src/once';
import compose from 'ramda/src/compose';

function onInput({ target }) {
	target.value = format(target.value);
}

export const InputPhoneMask = {
	functional: true,
	props: {
		value: String
	},
	render(h, { props, data, listeners }) {
		return (
			<input
				type="tel"
				{ ...data }
				domPropsValue={ format(props.value) }
				onInput={ onInput }
				onChange={ onInput }
				{ ...listeners }
			/>
		);
	}
}

export const InputPhoneMaskRU = {
	mixins: [ InputPhoneMask ],
	props: {
		value: {
			type: String,
			default: '7',
		},
	},
}

/**
 * Register vue component `input-phone-mask` and return it
 */
const registerComponent = once(
	() => (
		Vue.component('input-phone-mask', InputPhoneMaskRU),
		Vue.component('input-phone-mask')
	)
);

/**
 * Select all `[is="input-phone-mask"]` elements in the DOM
 * and initialize them
 */
const initExistingElements = () =>
	document
		.querySelectorAll('[is="input-phone-mask"]')
		.forEach((el) => new Vue({ el }));

/**
 * @see registerComponent
 * @see initExistingElements
 */
export const init = compose(
	initExistingElements,
	registerComponent
);

BX.namespace('InputPhoneMask');
BX.InputPhoneMask.init = init;
